export const STATUSIMOVELGARANTIAS = {
  A: 'ATIVO',
  Q: 'QUITADO'
};
